import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "redux/store";
import reportActions from "redux/app/report/actions";
import reportSelectors from "redux/app/report/selectors";
import EmfUsageTable from "./_elements/EmfUsageTable";
import moment from "moment";

type OwnProps = {};
type EmfUsageProps = PropsFromRedux & OwnProps;
function EmfUsage(props: EmfUsageProps) {
	const reportContainerRef = useRef<HTMLDivElement>(null);
	const [yearMonth, setYearMonth] = useState(moment().format("YYYY-MM"));

	useEffect(() => {
		props.loadEmfFleetUsageData(yearMonth);
	}, [yearMonth]);

	return (
		<div
			ref={reportContainerRef}
			className="bg-white m-2 rounded-lg h-[calc(100vh-98px)] overflow-y-auto"
		>
			<div className="">
				<div className="px-5 pb-0 py-8">
					<div className="flex items-center">
						<span
							title="go back"
							onClick={() => {
								window?.history?.back();
							}}
							className="bp3-icon bp3-icon-arrow-left text-lg mr-3 cursor-pointer"
						/>
						<h2 className="text-xl font-medium">Fleet Level EMF Usage</h2>
					</div>
					<div className="flex items-center justify-between">
						<div className="flex items-center">
							<div className="flex  items-baseline">
								<div className="mt-4 ml-3 pl-4 min-w-28 md:w-56">
									<input
										type="month"
										id="emfMonthSelect"
										className="p-1 border border-gray-300 rounded-sm shadow-sm bg-gray-100 text-sm"
										value={yearMonth}
										onChange={(e) => {
											setYearMonth(e.target.value);
										}}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<EmfUsageTable />
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const reportStore = reportSelectors._getStore(store);
	const jobToLoadEmfFleetUsageData =
		reportSelectors.jobToLoadEmfFleetUsageData(reportStore);
	return {
		jobToLoadEmfFleetUsageData,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {
		loadEmfFleetUsageData(yearMonth: string) {
			dispatch(reportActions.commands.emfFleetUsageDataLoad(yearMonth));
		},
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(EmfUsage);
